"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stampDutyHelper = void 0;
exports.stampDutyHelper = {
    isString: function (value) { return typeof value === 'string'; },
    isStringArray: function (value) {
        return value.length > 0 && typeof value[0] === 'string';
    },
    isSubitem: function (value) {
        return value.length > 0 &&
            typeof value[0].item === 'string';
    },
    isAmountValue: function (value) {
        return typeof value.purchaseAmountOrValue === 'string';
    }
};
